<template>
  <div class="aboutUs">
    <div class="abuoutContent">
      <ProductContent :title="title" :content="content" />
      <div class="introBox introWrap" :style="{position:'relative',width:'1200px'}">
        <div
          :style="{width:'320px',height:'440px'}"
          v-for="(item,index) in aboutData"
          :key="index"
          @mouseleave="leaver(index)"
          @mouseenter="enters(index)"
          class="introOver"
        >
          <div class="introContent" :style="{'backgroundImage': 'url(' + item.imgUrl + ')'}"></div>
          <div class="mask">
            <div class="maskItem">
              <p class="maskTitle">{{maskData[index].title}}</p>
              <p class="maskContent">{{maskData[index].content}}</p>
              <div :style="{marginLeft:'35px',marginRight:'35px',marginTop:'20px'}">
                <img :style="{width:'100%'}" :src="maskData[index].imgUrl" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="title companyTitle">
        <LineContent class="lineContent" />
        <span class="vertical"></span>
        <p class="subTitle">公司文化</p>
      </div>
      <div class="introBox introImg">
        <img class="introImgItem" src="@/assets/images/introone.png" alt />
        <img class="introImgItem" src="@/assets/images/introTwo.png" alt />
        <img class="introImgItem" src="@/assets/images/introThree.png" alt />
      </div>
      <div class="mobilCompany">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="(item,index) in mobileCompanyData" :key="index" class="swiperItem">
          <img :src="item.imgUrl" alt="">
        </swiper-slide>
        <div class="swiper-pagination"  slot="pagination"></div>
      </swiper>
    </div>
      <div class="company">
        <div class></div>
      </div>
      <div class="title">
        <LineContent class="lineContent" />
        <span class="vertical"></span>
        <p class="subTitle">合作单位</p>
      </div>
      <div class="cooperate">
        <img src="@/assets/images/albb.png" alt />
        <img src="@/assets/images/eqb.png" alt />
        <img src="@/assets/images/zqyl.png" alt />
        <img src="@/assets/images/shyh.png" alt />
        <img src="@/assets/images/zgjsyh.png" alt />
        <img src="@/assets/images/zgnyyh.png" alt />
        <img src="@/assets/images/zggsyh.png" alt />
        <img src="@/assets/images/xyyh.png" alt />
      </div>
      <p :style="{textAlign:'end',color:'#999999'}" class="remark">*排名不分先后</p>
    </div>
    
  </div>
  
</template>

<script>
import ProductContent from "@/components/ProductContent";
import LineContent from "@/components/LineContent";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
export default {
  components: {
    ProductContent,
    LineContent,
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      swiperOptions: {
        pagination: '.swiper-pagination',
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        slidesPerView: 1,
        paginationClickable: true,
      },
      mobileCompanyData:[
        {imgUrl:require("../assets/images/introone.png")},
        {imgUrl:require("../assets/images/introTwo.png")},
        {imgUrl:require("../assets/images/introThree.png")}
      ],
      aboutData: [
        {
          imgUrl: require("../assets/images/aboutUsOne.png"),
          textUrl: require("../assets/images/aboutUsTwo.png"),
        },
        {
          imgUrl: require("../assets/images/aboutUsTwo.png"),
          textUrl: require("../assets/images/aboutUsTwo.png"),
        },
        {
          imgUrl: require("../assets/images/aboutUsThree.png"),
          textUrl: require("../assets/images/aboutUsTwo.png"),
        },
      ],
      maskData: [
        {
          title: "国有企业",
          content:
            "山东省商业集团有限公司，简称“鲁商集团”，是1992年底由山东省商业厅整建制转体组建而成的国有企业，现高度聚焦零售产业和健康产业两大主业，教育作为支撑。",
        },
        {
          title: "实力雄厚",
          content:
            "鲁商集团拥有3家上市公司，银座股份、鲁商发展和鲁商服务。拥有四个中国驰名商标，银座、润洁、明仁、伊帕尔汗。拥有4所高校、8个国家级研发平台、6个院士工作站，下属企业307家，从业人员20万人，资产总额1340亿元。",
        },
        { title: "合法合规",content:"电信备案号：鲁ICP备19034510号",imgUrl:require("../assets/images/yfkpz.png"),},
      ],
      title: "关于我们",
      content:
        "鲁商通充分发挥鲁商集团资源优势，围绕集团旗下成员企业、企业员工，集团各产业的顾客、会员及上下游产业链企业，及与集团合作的金融机构、技术服务机构、数据服务机构、专业中介机构等形成的鲁商生态圈，挖掘需求和痛点，以移动互联网为支撑，以新兴数字科技为手段，以鲁商通APP为载体，不断创新和研发产品与服务，为使鲁商生态更加繁荣、温暖而不懈努力。",
    };
  },
  methods: {
    enters(index) {
      window.console.log(index);
      // this.switchNice[index].showImg = false; //图片隐藏
      // this.switchNice[index].showText = true; // 文字显示
    },
    leaver(index) {
      window.console.log(index);
      // this.switchNice[index].showImg = true; //图片隐藏
      // this.switchNice[index].showText = false; // 文字显示
    },
  },
};
</script>
<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
::v-deep .midText {
  background: #fbf6f3;
}
.introWrap {
  position: relative;
  width: 800px;
  // height: 500px;
}
.introContent {
  background-repeat: no-repeat;
  background-size: contain;
  width: 320px;
  height: 440px;
  position: absolute;
  transition: opacity 0.3s ease 0s;
  background-repeat: no-repeat;
  background-size: 107%;
}
.mask {
  width: 320px;
  height: 440px;
  // width: 100%;
  // height: 100%;
  overflow: hidden;
  position: absolute;
  // background: linear-gradient(
  //   -58deg,
  //   rgba(249, 81, 2, 1),
  //   rgba(254, 117, 6, 1)
  // );
  background-color: #ec5f20;
  opacity: 0;
  transition: opacity 0.8s ease 0s;
  color: #fbf6f3;
  &:hover {
    opacity: 1;
    transition: opacity 0.8s ease 0s;
  }
}
.maskTitle {
  font-size: 24px;
  text-align: center;
  padding-bottom: 20px;
  padding-top: 35px;
}
.maskContent {
  font-size: 18px;
  padding-left: 35px;
  padding-right: 35px;
  text-align: justify;
  line-height: 37px;
}
.aboutUs {
  background-color: #fbf6f3;
  color: #000000;
  margin: 0 auto;
  padding-bottom: 180px;
}
.abuoutContent {
  width: 1200px;
  margin: 0 auto;
}
.introBox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 84px;
  img{
    width: 100%;
  }
}
.title {
  text-align: center;
  margin-top: 80px;
  margin-bottom: 80px;
}
.cooperate {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  img {
    margin-bottom: 40px;
  }
}
.introImg {
  justify-content: flex-start;
  .introImgItem {
    width: 33%;
  }
}
.aboutText {
  width: 50%;
  transform: scale(1.3);
  transition: transform 3s ease 0s;
}
.aboutImg {
  width: 50%;
  transform: scale(1.3);
  transition: transform 3s ease 0s;
}
.swiperItem{
  img{
    width: 100%;
  }
}
.mobilCompany{
  display: none;
}
.subTitle{
  font-size: 28px;
}
@media (max-width: 767.98px) {
::v-deep .midText {
  background: #ffffff !important;
}
  .abuoutContent{
    width: 100%;
  }
  .aboutUs{
    background: #ffffff;
    padding-bottom: 30px;
  }
  .introWrap{
    width: 100% !important;
  }
  .introOver{
    width: 100% !important;
    margin-bottom: 30px;
  }
  .introBox{
    flex-direction: column;
  }
  .introContent{
    width: 90%;
    margin-left: 5%;
    border-radius: 20px;
  }
  .mask{
    width: 90%;
    margin-left: 5%;
    border-radius: 20px;
  }
  .introImg{
    display: none;
  }
  .mobilCompany{
  display: block;
}
.cooperate{
  justify-content: start;
  img{
    width: 32%;
    margin-bottom: -22px;
  }
}
.remark{
  margin-right: 30px;
  font-size: 13px;
}
.lineContent{
  display: none;
}
.vertical{
    width: 3px;
    height: 15px;
    background: #eb6100;
    border-radius: 1px 1px 1px 1px;
    display: inline-block;
    margin-right: 14px;
    margin-bottom: -4px;
}
.title{
    text-align: inherit;
    width: 90%;
    margin-left: 5%;
    margin-bottom: 0;
    margin-top: 20px;
}
.subTitle{
  display: inline-block;
  font-size: 15px;
  // text-align: 15px !important;
}
.companyTitle{
  margin-bottom: 20px;
}
.introBox {
  margin-bottom: 0;
}
}
</style>